module.exports = __webpack_public_path__ + "img/657-413100.png";